import { render, staticRenderFns } from "./VerboseCell.vue?vue&type=template&id=641edd2e&scoped=true&"
import script from "./VerboseCell.vue?vue&type=script&lang=js&"
export * from "./VerboseCell.vue?vue&type=script&lang=js&"
import style0 from "./VerboseCell.vue?vue&type=style&index=0&id=641edd2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641edd2e",
  null
  
)

export default component.exports